// src/assets/backgrounds.js
export const BACKGROUNDS = [
  // Fundo 1 - Estádio com néon verde
  require('../assets/images/stadium1.png'),
  // Fundo 2 - Campo com néon azul (use uma imagem similar ou a mesma)
  require('../assets/images/stadium2.png'),
  // Fundo 3 - Estádio com néon roxo (use uma imagem similar ou a mesma)
  require('../assets/images/stadium3.png'),
];